
import './styles/reset.quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/mdi-v7/mdi-v7.css'
export default {
  config: {},
  plugins: {
  }
}